export const RedesignedFiltersPanelId = 'RedesignedFiltersPanel';
